var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCartSidebar = function SvgCartSidebar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 28.205 28.098"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "shopping-cart (1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.829 25.804a2.294 2.294 0 1 0 2.294-2.294 2.3 2.3 0 0 0-2.294 2.294M23.573 25.804a2.294 2.294 0 1 0-2.294 2.294 2.3 2.3 0 0 0 2.294-2.294"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(34,203,91,0.12)",
    d: "M4.845 6.213h22.166L24.1 19.176H6.206Z",
    "data-name": "Path 18947"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2,
    d: "m3.118 2.046 1.671 15.87a2.914 2.914 0 0 0 2.9 2.613h15.173a2.937 2.937 0 0 0 2.856-2.307l2.338-10.9a1.947 1.947 0 0 0-1.9-2.353H5.383L4.962.972A.974.974 0 0 0 3.994.1H1.073a.973.973 0 1 0 0 1.946ZM26.151 6.91l-2.337 10.9a.98.98 0 0 1-.953.769H7.694a.971.971 0 0 1-.969-.871L5.587 6.91Z"
  }))));
};
export default SvgCartSidebar;